import {
  SELECT_ALL_TRAFFIC_OPERATORS,
  DESELECT_ALL_TRAFFIC_OPERATORS,
  TRAFFIC_OPERATORS_CHECKED,
} from "../actions/types/TrafficOperatorActionTypes";
import filterOperatorCodesIfExistsInPostalOperators from "../filters/filterOperatorCodesIfExistsInPostalOperators";

export const initialState = {
  checkedOperator: [],
  nodesForOperator: [
    { value: "excludeEtoes", label: "Exclude ETOE" },
    { value: "excludeInternalTraffic", label: "Exclude Internal Traffic" },
  ],
};

export const trafficPostalOperatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_ALL_TRAFFIC_OPERATORS:
      return {
        ...state,
        checkedOperator: action.payload.nodes.map((node) => node.value),
      };

    case DESELECT_ALL_TRAFFIC_OPERATORS:
      return {
        ...state,
        checkedOperator: [],
      };

    case TRAFFIC_OPERATORS_CHECKED:
      return {
        ...state,
        checkedOperator: filterOperatorCodesIfExistsInPostalOperators(
          action.checkedTrafficOperators,
          state.nodesForOperator
        ),
      };

    default:
      return state;
  }
};
